import { createContext } from 'react';

const QuillContext = createContext();

export default QuillContext;
